export const EXPERT_SIGNIN_REQUEST = "EXPERT_SIGNIN_REQUEST";
export const EXPERT_SIGNIN_SUCCESS = "EXPERT_SIGNIN_SUCCESS";
export const EXPERT_SIGNIN_FAIL = "EXPERT_SIGNIN_FAIL";

export const EXPERT_REGISTER_REQUEST = "EXPERT_REGISTER_REQUEST";
export const EXPERT_REGISTER_SUCCESS = "EXPERT_REGISTER_SUCCESS";
export const EXPERT_REGISTER_FAIL = "EXPERT_REGISTER_FAIL";

export const EXPERT_GOOGLE_REQUEST = "EXPERT_GOOGLE_REQUEST";
export const EXPERT_GOOGLE_SUCCESS = "EXPERT_GOOGLE_SUCCESS";
export const EXPERT_GOOGLE_FAIL = "EXPERT_GOOGLE_FAIL";

export const EXPERT_UPDATE_REQUEST = "EXPERT_UPDATE_REQUEST";
export const EXPERT_UPDATE_SUCCESS = "EXPERT_UPDATE_SUCCESS";
export const EXPERT_UPDATE_FAIL = "EXPERT_UPDATE_FAIL";

export const EXPERT_LOGOUT = "EXPERT_LOGOUT";
